import React from 'react';
import { ControlledList } from 'framework/list';
import useInvoiceService from 'domain/finance/invoice/useInvoiceService';
import { SensitiveListElementLayout } from 'framework/sensitiveData';
import { usePurchaseOrderUrl } from 'domain/finance/purchaseOrder/shared/usePurchaseOrderRouting';
import InvoicesListDataGrid from 'domain/finance/purchaseOrder/shared/field/InvoicesListDataGrid';
import { useFieldHelper } from 'framework/ui/field';
import usePurchaseOrderSettings from 'domain/finance/purchaseOrder/shared/Settings/usePurchaseOrderSettings';
import PurchaseOrderSettings from 'domain/finance/purchaseOrder/shared/Settings';
import { Box, Typography } from '@mui/material';

const InvoicesListField = ({
  source,
  isSensitiveDataIsShown = false,
}: {
  source: string;
  isSensitiveDataIsShown?: boolean;
}) => {
  const { areDeliversInvoicesVisible } = usePurchaseOrderSettings();
  const { getSensitiveDataByIds } = useInvoiceService();
  const { getListUrl } = usePurchaseOrderUrl();
  const { getValue } = useFieldHelper({ source });
  let invoices = (getValue() as any) || [];

  if (!areDeliversInvoicesVisible) {
    invoices = invoices.filter((invoice: any) => !invoice.deliveryStatus);
  }

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: { xs: '28px', sm: '30px' },
        }}
      >
        <Typography variant="h4" color="primary">
          Goods and services
        </Typography>
        <PurchaseOrderSettings />
      </Box>
      <ControlledList
        data={{
          items: invoices.map((invoice: any) => ({ invoice, invoiceId: invoice.id })),
          totalPages: 1,
          totalElements: invoices.length,
        }}
      >
        <SensitiveListElementLayout
          key={`sensitive-${isSensitiveDataIsShown}`}
          sensitiveDataIdSource="invoiceId"
          loadSensitiveDataMethod={getSensitiveDataByIds}
          timerId={getListUrl()}
        >
          <InvoicesListDataGrid isSensitivePurchaseDataIsShown={isSensitiveDataIsShown} />
        </SensitiveListElementLayout>
      </ControlledList>
    </>
  );
};

export default InvoicesListField;
